import { AsyncPipe, DecimalPipe } from '@angular/common';
import { Component, HostBinding, OnInit, Type, inject } from '@angular/core';
import { Observable, catchError, combineLatest, of, shareReplay, switchMap, tap } from 'rxjs';
import { PanelService } from 'src/app/dashboards/panels/services/panel/panel.service';
import { VisibleDirective, waitUntilVisible } from 'src/app/panels/directives/visible/visible.directive';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { IKpiSubValue, IKpiValue } from 'src/app/panels/models/kpi-value';
import { NumberPipe } from 'src/app/panels/pipes/number/number.pipe';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { ErrorMessageComponent } from 'src/app/shared/components/error-message/error-message.component';
import { IDashboardParameters } from '../../../../dashboards/models/dashboard-parameters';
import { ColorService } from '../../../../shared/services/color/color.service';
import { Color } from '../../../../shared/services/color/colors';
import { PanelComponent } from '../../panel.component';

export const KPI_PANEL_IMPORTS: Type<unknown>[] = [
  CardComponent,
  VisibleDirective,
  ErrorMessageComponent,
  AsyncPipe,
  DecimalPipe,
  NumberPipe,
];

@Component({
  selector: 'app-kpi-panel',
  template: '',
})
export abstract class KpiPanelComponent extends PanelComponent implements OnInit {
  @HostBinding('class') public class = 'col-12 col-sm-6 col-lg-4 col-xl-3';

  public colorService = inject(ColorService);
  public color: Color = Color.Blue;
  public footerText$?: Observable<IDashboardParameters>;
  public total: number = 0;
  public subValues: IKpiSubValue[] | undefined;

  public override data$?: Observable<IKpiValue | null>;
  protected panelService = inject(PanelService);
  public abstract readonly unit?: DisplayUnit;
  public abstract override readonly icon?: string;

  ngOnInit(): void {
    this.footerText$ = this.dashboardParams$;
    this.data$ = combineLatest([this.dashboardParams$, this.visible$]).pipe(
      waitUntilVisible(this),
      switchMap((params) => {
        return this.panelService
          .getKpi(
            this.getType(),
            this.entityIds,
            params.timeRange.from,
            params.timeRange.till,
            params.timeRange.compareFrom,
            params.timeRange.compareTill,
          )
          .pipe(
            catchError(() => {
              this.error = 'Geen data';
              return of(null);
            }),
          );
      }),
      tap((data) => {
        this.total = data?.kpis.kpi.value ?? 0;
        this.subValues = data?.kpis.kpi.subTotals;
        this.loading = false;
      }),
      shareReplay(1),
    );
  }
}
